import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SlideView from "@/views/share/SlideView.vue";
import {h, reactive} from "vue";
import {MenuProps} from "ant-design-vue";
import {InfoCircleOutlined, UserOutlined} from "@ant-design/icons-vue";
import {useRoute} from "vue-router";
import router from "@/views";


export default /*@__PURE__*/_defineComponent({
  __name: 'ServiceSideView',
  setup(__props) {


const route = useRoute();
const info = reactive({
  menu: {
    toggle: false,
    items: [
      {key: 'service', icon: h(UserOutlined), label: 'VIP会员'},
      {key: 'theme', icon: h(UserOutlined), label: '订制主题'},
      {key: 'element', icon: h(UserOutlined), label: '订制元素'},
      {key: 'production', icon: h(UserOutlined), label: '代制作'},
      {key: 'teach', icon: h(UserOutlined), label: '在线操盘'},
      {key: 'ad', icon: h(UserOutlined), label: '自定义广告'},
    ] as MenuProps['items'],
    openKeys: [] as string[],
    selectedKeys: [route.path.split('/').last()] as string[],
  }
});

const onMenuClick = (e: any) => {
  if (e.key === 'service') router.push(`/service`);
  else router.push(`/service/${e.key}`);
}

return (_ctx: any,_cache: any) => {
  const _component_a_menu = _resolveComponent("a-menu")!

  return (_openBlock(), _createBlock(SlideView, {
    toggle: info.menu.toggle,
    "onUpdate:toggle": _cache[2] || (_cache[2] = ($event: any) => ((info.menu.toggle) = $event))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_menu, {
        items: info.menu.items,
        "inline-collapsed": info.menu.toggle,
        "open-keys": info.menu.openKeys,
        "onUpdate:openKeys": _cache[0] || (_cache[0] = ($event: any) => ((info.menu.openKeys) = $event)),
        "selected-keys": info.menu.selectedKeys,
        "onUpdate:selectedKeys": _cache[1] || (_cache[1] = ($event: any) => ((info.menu.selectedKeys) = $event)),
        mode: "inline",
        onClick: onMenuClick
      }, null, 8, ["items", "inline-collapsed", "open-keys", "selected-keys"])
    ]),
    _: 1
  }, 8, ["toggle"]))
}
}

})